import React from "react";
import "./index.scss";
import Button from "features/components/button";
import {__} from "services/i18n";
import {historyObject} from "historyObject";

export const ReportAProblemButton = (props) => {
    return <div className="report-problem-button">
        <Button title={__("buttons.report-problem")} onClick={() => historyObject.push("/help")} type={"clear"} />
    </div>
};